import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Helmet } from 'react-helmet';
import './home.css';
import { Link } from "react-router-dom";
import VideoSlider from './components/VideoSlider';
import Header from './components/Header';

import logoPaytm from '../src/images/logo-paytm.png';
import cbOnlineChallenge from '../src/images/choose-battle-online-challenge.png';
import cbOnGroundChallenge from '../src/images/choose-battle-on-ground-challenge.png';

import heroHome1 from '../src/images/hero-home-1.png';

import winDreamPrize from '../src/images/win-pic-dream-prize.png';
import winLuckyDrawPrize from '../src/images/win-pic-lucky-draw-prize.png';
import winSignedMerchandise from '../src/images/win-pic-signed-merchandise.png';

const prodList = [
  {
    "prodImg": "prod-cta-pride-4t-sae-10w-30.png"
  },
  {
    "prodImg": "prod-cta-pride-4t-sae-20w-40.png"
  },
  {
    "prodImg": "prod-cta-pride-4t-sae-20w-50.png"
  },
  {
    "prodImg": "prod-cta-pride-scooter-4t-sae-10w-30.png"
  },
]

function Home() {
  return (
    <div>
      <Helmet>
        <title>Gulf Pick-Up Your Dream | Gulf Oil India</title>
        <meta name="description" content="You are one video away from meeting your favourite cricketers and learning cricket from them. Don’t miss this opportunity of a lifetime!" />
      </Helmet>
      <section className="generic-padding hero-wrapper">
        <Container>
          <Header />
          <Row>
            <Col lg={6} className="pt-5">
              <img src={heroHome1} className="img-fluid" alt="Gulf Oil India" />
            </Col>
          </Row>
        </Container>
        <span className="hero-img hero-img-home"></span>
        <div className="hero-mask"></div>
      </section>
      <section className="generic-padding text-center home-mid-wrapper">
        <Container>
          <h2 className="sub-title home-sub-title text-orange">#PICKUPYOURDREAM2</h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 3 }}>
              <div className="video-thumb-wrapper video-slider">
                <VideoSlider />
                <div className="video-bg-shape video-bg-shape-1"></div>
                <div className="video-bg-shape video-bg-shape-2"></div>
                <div className="video-bg-texture"></div>
              </div>
            </Col>
          </Row>
          <h2 className="sub-title home-sub-title text-uppercase">WIN BIG <span className="text-orange">with gulf!!</span></h2>
          <div className="win-big-wrapper">
            <div className="win-big-band">
              <Row>
                <Col md={4}>
                  <img src={winDreamPrize} className="img-fluid" alt="" />
                  <div className="win-big-box">
                    <h3 className="text-uppercase">Dream Prize</h3>
                    <p><em>12 lucky winners stand a chance to learn cricket from <strong>M.S. Dhoni and Hardik Pandya</strong></em></p>
                  </div>
                </Col>
                <Col md={4}>
                  <img src={winLuckyDrawPrize} className="img-fluid" alt="" />
                  <div className="win-big-box">
                    <h3 className="text-uppercase">Lucky Draw Prize</h3>
                    <p><em>50 lucky winners get a chance to meet and greet the <strong>Chennai Super Kings team</strong></em></p>
                  </div>
                </Col>
                <Col md={4}>
                  <img src={winSignedMerchandise} className="img-fluid" alt="" />
                  <div className="win-big-box">
                    <h3 className="text-uppercase">Signed Merchandise</h3>
                    <p><em>100 lucky winners will get signed merchandise by <strong>M. S. Dhoni and Hardik Pandya</strong></em></p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
        <div className="choose-battle-wrapper">
          <Container>
            <h2 className="sub-title">Ready to win the prize ?<br />
              <span className="text-orange">Choose your battle</span><br /><small className="sub-title-normal text-orange">(click below)</small></h2>
            <Row className="mb-4">
              <Col md={5}>
                <Link to="/onlinechallenge" className="choose-battle-link"><img src={cbOnlineChallenge} className="img-fluid" alt="" /></Link>
              </Col>
              <Col md={2} className="align-self-center">
                <div className="choose-or-block">AND/OR</div>
              </Col>
              <Col md={5}>
                <Link to="/ongroundchallenge" className="choose-battle-link"><img src={cbOnGroundChallenge} className="img-fluid" alt="" /></Link>
              </Col>
            </Row>
            <p className="font-size-6"><em>Increase your chances of winning THE DREAM PRIZE by taking the ON-GROUND CHALLENGE</em></p>
          </Container>
        </div>
        <div className="home-mid-mask"></div>
      </section>
      <section className="generic-padding home-btm-wrapper">
        <Container>
          <h2 className="sub-title sub-title-blue text-center">PICK-UP A GULF PRIDE ENGINE OIL CAN AND TAKE THE CHALLENGE!</h2>
          <p className="text-center font-size-5 mb-4"><em>Special <img src={logoPaytm} alt="PayTM" className="mx-2" /> Rs. 30/- and Rs. 50/- available on the purchase of<br /> <strong>Pick-Up Your Dream Limited Edition packs</strong></em></p>
          <p className="text-orange font-size-5">Steps to Win PAYTM Cash (Assured prize)</p>
          <Row className="mb-4">
            <Col md={8}>
              <ol className="font-size-6 pl-4">
                <li>To purchase a Gulf Pride Engine Oil search the below products on www.amazon.in</li>
                <li>Check unique code on side label</li>
                <li>SMS GULF {`<SPACE>`} unique code to 9990988108</li>
              </ol>
            </Col>
          </Row>
          <Row className="text-center">
            {prodList.map((item, i) => {
              return (<Col xs={6} sm={3} lg={2} key={i}>
                <a href="https://www.amazon.in/Gulf/b/ref=bl_dp_s_web_10746867031?ie=UTF8&node=10746867031&field-lbr_brands_browse-bin=Gulf" target="_blank" rel="noopener noreferrer" title=""><img src={require(`../src/images/${item.prodImg}`)} className="img-fluid mb-4" alt="Gulf Pride Engine Oil" /></a>
              </Col>)
            })}
          </Row>
          <div className="home-graphic graphic-3"></div>
        </Container>
      </section>
    </div>
  );
}
export default Home;